import React, { FC } from 'react';
import { Product } from 'omni-package-react-core';
import { useTranslation } from 'react-i18next';
import { SideNav } from 'ia-react-core';

export interface SideNavGroupeInsuranceProps {
  product: Product;
}

const SideNavGroupeInsurance: FC<SideNavGroupeInsuranceProps> = ({ product }) => {
  const { t } = useTranslation('SideNavGroupeInsurance');

  return (
    <SideNav.Link id={product.id} key={product.id} to={product.browsingValue} external>{t('productTypeTitle')}</SideNav.Link>
  );
};
export default SideNavGroupeInsurance;
